import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, TerminalInput } from '~/components';
import { usePath } from '~/hooks';
import { inputWidth } from '~/utils/filters';

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { changePath, params } = usePath();
  const { t } = useTranslation('paymentDetails');

  const handleChange = (changed: any, values: Record<string, any>) => {
    changePath({ filter: values });
  };

  return (
    <Form form={form} layout="inline" onValuesChange={handleChange} initialValues={params.filter}>
      <Form.Item name="terminalId">
        <TerminalInput placeholder={t('terminal')} style={inputWidth} />
      </Form.Item>
    </Form>
  );
};

export default Filters;
